export default {
  'description.header': {
    id: 'modelPopup.description.header',
    defaultMessage: 'Description'
  },
  'baseType.header': {
    id: 'modelPopup.baseType.header',
    defaultMessage: 'Base Type'
  }
};